import request from '@/utils/request'

/**
 * @description 获取资料列表
 * @param {*} data
 */
export function getFileList(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.GetFileList', data)
}
/**
 * @description 更新资料审核状态、校对状态
 * @param {*} data
 */
export function updateFileState(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.UpdateFileState', data)
}
/**
 * @description 设置资料审核状态，支持批量操作
 * @param {*} data
 */
export function setFileAuditStatus(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.SetFileAuditStatus', data)
}
/**
 * @description 重新发布资料，支持批量操作
 * @param {*} data
 */
export function republishFile(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.RepublishFile', data)
}
/**
 * @description 资料置顶
 * @param {*} data
 */
export function setFileTop(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.SetFileTop', data)
}
/**
 * @description 设置资料免费
 * @param {*} data
 */
export function setFileFree(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.SetFileFree', data)
}
/**
 * @description 发布到考讯
 * @param {*} data
 */
export function addKaoxun(data) {
  return request.post('/phalapi/public/?service=Tiku.KaoXun.addKaoxun', data)
}
/**
 * @description 删除资料
 * @param {*} data
 */
export function deleteFile(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.DeleteFile', data)
}
/**
 * @description 重新生成资料PDF
 * @param {*} data
 */
export function rebuildFilePdf(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.RebuildFilePdf', data)
}
/**
 * @description 获取资料详情
 * @param {*} data
 */
export function getFileInfo(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.GetFileInfo', data)
}
/**
 * @description 获取考试商品标签和年份
 * @param {*} data
 */
export function getExamTagsAndYear(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.GetExamTagsAndYear', data)
}
/**
 * @description 保存资料内容
 * @param {*} data
 */
export function saveFileInfo(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.SaveFileInfo', data)
}
/**
 * @description 修改资料发布时间
 * @param {*} data
 */
export function setFilePubdate(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.SetFilePubdate', data)
}
/**
 * @description 修改资料过期时间
 * @param {*} data
 */
export function setExpireAfterExam(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.SetExpireAfterExam', data)
}
/**
 * @description 复制资料到其他考试
 * @param {*} data
 */
export function copyFile(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.CopyFile', data)
}

/**
 * @description 上传pdf链接
 * @param {*} data
 */
export function updateTmpPdf(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.updateTmpPdf', data)
}
/**
 * @description 检查转换状态
 * @param {*} data
 */
export function getTmpPdfState(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.getTmpPdfState', data)
}

/**
 * @description 获取模版消息关联的公众号
 * @param {*} data
 */
export function getTemplateRelationAccountsApi(data) {
  return request.post('/phalapi/public/?service=App.WeiXin.GetTemplateRelationAccounts', data)
}
/**
 * @description 获取模板消息
 * @param {*} data
 */
export function getTplByGoodsApi(data) {
  return request.post('/phalapi/public/?service=App.Information.GetTplByGoods', data)
}
/**
 * @description 资料模板消息预览
 * @param {*} data
 */
export function previewZiliaoTplMsgApi(data) {
  return request.post('/phalapi/public/?service=App.Information.PreviewZiliaoTplMsg', data)
}
/**
 * @description 新增模板消息
 * @param {*} data
 */
export function saveGoodsTemplateApi(data) {
  return request.post('/phalapi/public/?service=App.Information.SaveGoodsTemplate', data)
}
/**
 * @description 获取资料待推送模板消息列表
 * @param {*} data
 */
export function getZiliaoPendingTplMsgsApi(data) {
  return request.post('/phalapi/public/?service=App.Information.GetZiliaoPendingTplMsgs', data)
}
/**
 * @description 删除待推送模板消息记录
 * @param {*} data
 */
export function deletePendingTplMsgApi(data) {
  return request.post('/phalapi/public/?service=App.Information.DeletePendingTplMsg', data)
}
/**
 * @description 获取资料设置
 * @param {*} data
 */
export function getSettingByNameApi(data) {
  return request.post('/phalapi/public/?service=App.Common.GetSettingByName', data)
}
/**
 * @description 获取科目列表
 * @param {*} data
 */
export function getSubjectsAndVerionApi(data) {
  return request.post('/phalapi/public/?service=Tiku.Exam.GetSubjectsAndVerion', data)
}
/**
 * @description 新版保存资料内容
 * @param {*} data
 */
export function saveFileInfoV2Api(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.SaveFileInfoV2', data)
}
/**
 * @description 资料取题
 * @param {*} data
 */
export function getFileQuestionsApi(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.GetFileQuestions', data)
}
/**
 * @description 获取题目内容 -- 用于刷新题目
 * @param {*} data
 */
export function getQuetionContentApi(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.GetQuetionContent', data)
}
/**
 * @description 获取资料考试关联配置
 * @param {*} data
 */
export function getFileExamRelationApi(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.GetFileExamRelation', data)
}
/**
 * @description 保存资料考试关联配置
 * @param {*} data
 */
export function setFileExamRelationApi(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.SetFileExamRelation', data)
}
/**
 * @description 删除资料考试关联数据
 * @param {*} data
 */
export function deleteFileExamRelationApi(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.DeleteFileExamRelation', data)
}
/**
 * @description 获取考试当前年份的题库版本占分比模板列表
 * @param {*} data
 */
export function getExamPercentageTmplsApi(data) {
  return request.post('/phalapi/public/?service=Tiku.TikuVersion.getPercentageTmpls', data)
}
/**
 * @description 获取生成资料标题标记内容
 * @param {*} data
 */
export function getFileMarkContentApi(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.GetFileMarkContent', data)
}

/**
 * @description 复制考前资料
 * @param {*} data
 */
export function copyKaoqianZiliao(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.copyKaoqianZiliao', data)
}

/**
 * @description 提交PDF转HTML任务
 * @param {*} data
 */
export function submitPdfToHtml(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.submitPdfToHtml', data)
}

/**
 * @description 获取PDF转HTML任务状态
 * @param {*} data
 */
export function getPdfToHtmlState(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.getPdfToHtmlState', data)
}

/**
 * @description 判断pdf是否更新成功
 * @param {*} data
 */
export function getPdfUpdatingState(data) {
  return request.post('/phalapi/public/?service=Ziliao.File.getPdfUpdatingState', data)
}
